<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<style>
  @import "./common/font/font.css";
</style>
<script>
export default {
  name: 'App'
}
</script>




// WEBPACK FOOTER //
// src/App.vue